export default {
  version: (state) => state.version
};
